import { render, staticRenderFns } from "./WorkerConsultCard.vue?vue&type=template&id=6b6ab322"
import script from "./WorkerConsultCard.vue?vue&type=script&lang=ts"
export * from "./WorkerConsultCard.vue?vue&type=script&lang=ts"
import style0 from "./WorkerConsultCard.vue?vue&type=style&index=0&id=6b6ab322&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports